'use strict';

const light = {
    badge: {
        height: "16px",
        minWidth: "16px",
        fontSize: "12px",
    },
    anchorOriginTopRightRectangular: {
        top: "-6px",
        right: "-6px",
    },
};

var MuiBadge = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiBadge = MuiBadge;
exports.light = light;
